import { GET_ORDER_CANCEL_REASONS_SUCCESS } from './lookupsConstants'

const initialState = {
  orderCancelReasons: [],
}

// @ts-expect-error TS7006 TEMP ERROR SUPPRESSION: CRA -> REACT ROUTER
export default function lookupsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ORDER_CANCEL_REASONS_SUCCESS:
      return {
        ...state,
        orderCancelReasons: action.payload,
      }
    default:
      return state
  }
}
